import { el, text } from "./utils"
import Top from "./top"
import { ILocation } from "./models";

export default class Locations{
  private element: HTMLDivElement
  private hideListener: () => void = () => false
  private top: Top
  constructor(el: HTMLDivElement, top: Top) {
    this.element = el
    this.render(window.FORM_LOCATIONS)
    this.top = top
  }
  flipContent(message: string | HTMLElement){
    let content: HTMLElement | string = ''
    if (typeof message == 'string'){
      content = el('h3', {
        children: [
          text(message)
        ]
      })
    } else {
      content = message
    }
    this.element.innerHTML = ''
    this.top.message(
      el('div', {
        attrs: {
          class: "response"
        },
        children: [ content ]
      }),
      2
    )
  }
  handleClick(isOpen: boolean){
    if(isOpen){
      this.hide()
    } else {
      this.flipContent('This location is currently not open.')
    }
  }
  renderLocation(location: ILocation){
    var link = el('a', {
      attrs: {
        href: '#'
      },
      children:[
        text(location.locationName)
      ]
    })
    link.addEventListener('click', () => this.handleClick(parseInt(location.locationOpen) === 1))
    return el('div', {
      attrs: {
        class: 'location'
      },
      children:[
        link
      ]
    })
  }
  render(data: Array<ILocation>){
    this.element.appendChild(el('div', {
      children: [
        el('h3', {
          children: [text('Select your current location')]
        }),
        ...data.map(location => {
          return this.renderLocation(location)
        })
      ]
    }))
  }
  onhide(cb: () => void){
    this.hideListener = cb
  }
  private hide(){
    this.element.style.display = 'none'
    this.hideListener()
  }
}